// src/store.js
import { configureStore } from '@reduxjs/toolkit';

import applicationReducer from './slices/applicationSlice';
import componentReducer from './slices/componentSlice';
import jobReducer from './slices/jobSlice';
import channelReducer from './slices/channelSlice';
import authReducer from './slices/authSlice';
import analysisResultReducer from './slices/analysisResultSlice';
import clusterReducer from './slices/clusterSlice';
import konceptsReducer from './slices/konceptsSlice';
import selectionReducer from './slices/selectionSlice';
import metricsReducer from './slices/metricsSlice';
import mapReducer from './slices/mapSlice';
import testbedReducer from './slices/testbedSlice';
import aggregationsReducer from "./slices/aggregationsSlice";

const store = configureStore({
  reducer: {
    applications: applicationReducer,
    components: componentReducer,
    jobs: jobReducer,
    channels: channelReducer,
    authentication: authReducer,
    analysisResult: analysisResultReducer,
    cluster: clusterReducer,
    koncepts: konceptsReducer,
    selection: selectionReducer,
    metrics: metricsReducer,
    map: mapReducer,
    testbed: testbedReducer,
    aggregations : aggregationsReducer,
  },
  
});

export default store;
